import { appGetDataState } from '../../selectors';
import { appGetData } from '../../actions';
import withReduxData from '../../hoc/withReduxData';
import Main from '../../components/Main';

const mapStateToProps = state => ({
  data: appGetDataState(state)
});

const mapDispatchToProps = dispatch => {
  return {
    appGetData() {
      dispatch(appGetData());
    }
  };
};

export default withReduxData(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/MainContainer/index.js